import { useQuery } from "@tanstack/react-query";
import { ShipmentTruckingGuestInfoResponseDto } from "../dtos/ShipmentTruckingGuestInfoResponseDto";
import { shipmentTruckingGuestService } from "../services/shipmentTruckingGuestService";

export const TRUCKING_GUEST_INFO_KEY = "shipment-trucking-guest-info";

export const useShipmentTruckingGuestInfo = (shipmentTruckingId: string | null | undefined) => {
  return useQuery<ShipmentTruckingGuestInfoResponseDto & { isCompleted?: boolean }>({
    queryKey: [TRUCKING_GUEST_INFO_KEY, shipmentTruckingId],
    queryFn: async () => {
      try {
        return await shipmentTruckingGuestService.getRoutes(shipmentTruckingId!);
      } catch (err: any) {
        const code = err?.response?.data?.code;

        if (code === 1022) {
          return {
            routePoints: [],
            isCompleted: true,
          } as unknown as ShipmentTruckingGuestInfoResponseDto & { isCompleted: boolean };
        }
        throw err;
      }
    },
    enabled: !!shipmentTruckingId,
    retry: false, // tránh spam call lại khi đã completed
  });
};